import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import { APP_LANGS, useLanguage, type AppLang } from "@/shared/hooks/useLanguage";

export function LanguageToggle(): JSX.Element {
  const { t } = useTranslation("common");
  const [current, setLanguage] = useLanguage();

  return (
    <div
      role="group"
      aria-label={t("language.label")}
      data-testid="language-toggle"
      className="inline-flex overflow-hidden rounded-md border border-[var(--border-default)]"
    >
      {APP_LANGS.map((lang: AppLang) => (
        <button
          key={lang}
          type="button"
          onClick={() => setLanguage(lang)}
          aria-pressed={current === lang}
          aria-label={t(`language.${lang}`)}
          data-testid={`language-toggle-${lang}`}
          className={[
            "h-8 w-9 text-xs font-semibold uppercase transition-colors",
            current === lang
              ? "bg-[var(--brand-500)] text-[var(--text-inverse)]"
              : "bg-white text-[var(--text-subtle)] hover:bg-[var(--surface-sunken)]",
          ].join(" ")}
        >
          {lang}
        </button>
      ))}
    </div>
  );
}
